import { render, staticRenderFns } from "./BigUserAlarmPage.vue?vue&type=template&id=64871e23&scoped=true"
import script from "./BigUserAlarmPage.vue?vue&type=script&lang=js"
export * from "./BigUserAlarmPage.vue?vue&type=script&lang=js"
import style0 from "./BigUserAlarmPage.vue?vue&type=style&index=0&id=64871e23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64871e23",
  null
  
)

export default component.exports